import { createAsyncThunk } from '@reduxjs/toolkit';
import invoiceApi from '~/apis/invoice';
import { CREATE_INVOICE, GET_INVOICE, GET_INVOICES, UPDATE_INVOICE } from '~/utils/constants/actionType';
import { IEditInvoice, IInvoice, IParamsGetInvoices, IResponseGetInvoices } from '~/utils/interface/invoice';

export const handleGetInvoices = createAsyncThunk<IResponseGetInvoices, IParamsGetInvoices>(
  GET_INVOICES,
  async (params: IParamsGetInvoices = {}, { rejectWithValue }) => {
    try {
      const res = await invoiceApi.getInvoices(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateInvoice = createAsyncThunk<IInvoice, IEditInvoice>(
  CREATE_INVOICE,
  async (data: IEditInvoice, { rejectWithValue }) => {
    try {
      const res = await invoiceApi.create(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetInvoice = createAsyncThunk<IInvoice, string>(
  GET_INVOICE,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await invoiceApi.getInvoice(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateInvoice = createAsyncThunk<IInvoice, { id: string; data: IEditInvoice }>(
  UPDATE_INVOICE,
  async (data: { id: string; data: IEditInvoice }, { rejectWithValue }) => {
    try {
      const res = await invoiceApi.update(data.id, data.data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
